export class DatabaseSync {

    constructor(XRayUIState, $scope, $timeout, DatabaseSyncDao, XRayUIModelSaver, HomepageDao, JFrogEventBus,$rootScope) {
        this.DatabaseSyncDao = DatabaseSyncDao;
        $rootScope.h1Header='Database Sync';
        this.XRayUIState = XRayUIState;
        this.$timeout = $timeout;
        this.modelSaver = XRayUIModelSaver.createInstance(this, ['settings']);
        this.homepageDao = HomepageDao;
        this.JFrogEventBus = JFrogEventBus;
	    let EVENTS = JFrogEventBus.getEventsDefinition();
	    let removeListener = JFrogEventBus.register(EVENTS.UPDATE_STATUS_FETCHED,

		    (data) => {
	        if(data.updateOrigin !== 'interval'){
                this.sync = {
                    mode: data.updates_mode,
                    state: data.state
                };
            }

		    });
	    $scope.$on('$destroy', () => {
            $rootScope.h1Header='';
		    removeListener();
        });
        $scope.$parent.Settings.showButtons = false;
        $scope.$parent.Settings.currentSubController = this;
        this.vulnerabilitiesPath = "${XRAY_HOME}/var/work/updates/vulnerability";
        this.componentsPath = "${XRAY_HOME}/var/work/updates/component";
        $scope.steps = [
            "Click the Generate Download Command, copy the output command snippet and run it in the CLI",
            "Copy the downloaded update file from your DMZ environment to the Xray server:<ul><li>" + this.componentsPath + "</li><li>" + this.vulnerabilitiesPath + "</li></ul>",
            "Click the Upload local Update to upload the file and update the database",
        ]
        this.sync = {};
        this.EVENTS = JFrogEventBus.getEventsDefinition();


    }

    getUpdateData(data) {
        this.updateData = {
            updated: data.last_updated,
            state: data.state,
            updates_mode: data.updates_mode
        }
        this.sync = {
            mode: this.updateData.updates_mode
        };

        if (this.XRayUIState.getState('offline_sync_require')) {
            this.sync.mode = 'offline';
        }
    }

    fireUpdateEvent() {
        this.JFrogEventBus.dispatch(this.EVENTS.UPDATE_STATUS_CHANGE);
    }


    getCliCommand() {
        this.DatabaseSyncDao.getCliSnippet().$promise.then((response) => {
            this.cliSnippet = response.snippet;
            this.$timeout(() => this.openCollapse = true)
        })
    }


    canSave() {
        return true;
    }
}



// WEBPACK FOOTER //
// ./modules/xray/states/settings/tabs/database_sync/database_sync.controller.js